import { QUERY_PARAM_CATEGORY_BREADCRUMBS, QUERY_PARAM_CATEGORY_ID } from '../constants'
import { useCategoryContext } from '../providers/category/category'
import { useConfig } from '../providers/config'

export const useCatalogUrl = (urlKey, params = {}, otherParams = {}) => {
	const {
		catalog: { urlKeySuffix },
	} = useConfig()

	const categoryContext = useCategoryContext() ?? {}

	const breadcrumbs = categoryContext?.[0]?.breadcrumbs ?? []
	const categoryId = categoryContext?.[0]?.id ?? null

	// remove empty params
	const filledParams = Object.entries(params).reduce((acc, [key, value]) => {
		return { ...acc, ...(value ? { [key]: value } : {}) }
	}, {})

	const queryParams = {
		...(breadcrumbs.length ? { [QUERY_PARAM_CATEGORY_BREADCRUMBS]: JSON.stringify(breadcrumbs) } : {}),
		...(categoryId ? { [QUERY_PARAM_CATEGORY_ID]: categoryId } : {}),
		...otherParams,
	}

	const search = new URLSearchParams(filledParams)
	const query = search.toString() ? `?${search.toString()}` : ''
	const pathname = urlKey ? `/${urlKey}${urlKeySuffix ?? '/'}` : undefined

	const as = pathname ? `${pathname}${query}` : undefined // as -> hide breadcrumbs params from the url

	return {
		pathname,
		query: {
			...filledParams,
			...queryParams,
		},
		as,
	}
}
